export default "__VITE_ASSET__Bb9rG3q8__"